/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
import { CLASS_REQUIRED_EL, CLASS_REQUIRED_GT, CLASS_REQUIRED_CU, COMPULSORY_ID_REQUIRED } from "../../Constants";
import { desc } from "./sort";

const DIVISIONS_REQUIRED = [CLASS_REQUIRED_EL, CLASS_REQUIRED_GT, CLASS_REQUIRED_CU, COMPULSORY_ID_REQUIRED];

export const isRequired = (division: string) => DIVISIONS_REQUIRED.includes(division);

const getRequiredCode = (division: string) => (isRequired(division) ? 1 : 0);

export const sortByRequired = (a: string, b: string) => {
    const _a = getRequiredCode(a);
    const _b = getRequiredCode(b);

    return desc(_a, _b);
};
